import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-p', 'LetterP', [["path",{"d":"M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5","key":"svg-0"}]]);